import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Heart, Star, CheckCircle2, User } from 'lucide-react';
interface Comment {
  id: number;
  handle: string;
  comment: string;
  likes: number;
  time: string;
  rating: number;
  liked?: boolean;
}
const initialComments: Comment[] = [{
  id: 1,
  handle: '@marek_trener_wwa',
  comment: 'Zastosowałem system planowania tygodniowego od pierwszego tygodnia. Oszczędzam ponad 10 godzin tygodniowo. Warto każdą złotówkę.',
  likes: 47,
  time: '3 godziny temu',
  rating: 5,
  liked: true
}, {
  id: 2,
  handle: '@tomasz_coach_krakow',
  comment: 'W ciągu dwóch tygodni skróciłem czas przygotowania o 80% bez zmiany metody trenowania. Wystarczyły checklisty.',
  likes: 32,
  time: '5 godzin temu',
  rating: 5
}, {
  id: 3,
  handle: '@rafal_trener_poznan',
  comment: 'Część dotycząca raportów dla rodziców otworzyła mi oczy. Nigdy wcześniej nie miałem tak jasnego systemu komunikacji.',
  likes: 28,
  time: '8 godzin temu',
  rating: 5,
  liked: true
}, {
  id: 4,
  handle: '@piotr_football_gdansk',
  comment: 'Materiałów jest mnóstwo. Na początku myślałem że nie wykorzystam wszystkiego — ale po uporządkowaniu każda strona ma sens.',
  likes: 19,
  time: '12 godzin temu',
  rating: 5
}, {
  id: 5,
  handle: '@krzysztof_coach_wroclaw',
  comment: 'Plan B na deszcz uratował mnie już kilka razy. Wcześniej każdy deszczowy dzień to był natychmiastowy chaos.',
  likes: 24,
  time: 'Wczoraj',
  rating: 5,
  liked: true
}];
const moreCommentsPool: Comment[] = [{
  id: 6,
  handle: '@michal_trener_lodz',
  comment: 'Gry ratunkowe z bonusu to mistrzostwo. Dzieciaki je uwielbiają, a ja mam spokój gdy coś idzie nie tak.',
  likes: 18,
  time: '6 godzin temu',
  rating: 5
}, {
  id: 7,
  handle: '@akademia_pilkarska_waw',
  comment: 'Używamy tego systemu w całej akademii. Standaryzacja pracy trenerów nigdy nie była tak prosta.',
  likes: 31,
  time: '14 godzin temu',
  rating: 5,
  liked: true
}, {
  id: 8,
  handle: '@pawel_coach_szczecin',
  comment: 'Kalendarz treningowy na cały rok to coś, czego szukałem od lat. Koniec z wymyślaniem wszystkiego na bieżąco.',
  likes: 22,
  time: '18 godzin temu',
  rating: 5
}, {
  id: 9,
  handle: '@trener_maciej_lublin',
  comment: 'Rodzice są zachwyceni nowymi raportami. Widzą, że pracujemy profesjonalnie i mają czarno na białym postępy dzieci.',
  likes: 41,
  time: 'Wczoraj',
  rating: 5,
  liked: true
}, {
  id: 10,
  handle: '@kamil_football_katowice',
  comment: 'Pobierasz i masz. Żadnego logowania, żadnych abonamentów. Mam to na tablecie i korzystam na każdym treningu.',
  likes: 15,
  time: 'Wczoraj',
  rating: 5
}, {
  id: 11,
  handle: '@dawid_trener_bydgoszcz',
  comment: 'Atlas trenera to kopalnia wiedzy. Nawet po 10 latach pracy znalazłem tam nowe, świetne rozwiązania.',
  likes: 27,
  time: '2 dni temu',
  rating: 5,
  liked: true
}, {
  id: 12,
  handle: '@lukasz_coach_bialystok',
  comment: 'Szybkie odprawy przed meczem działają cuda. Chłopaki wychodzą na boisko z zupełnie innym nastawieniem.',
  likes: 19,
  time: '2 dni temu',
  rating: 5
}];
export function SocialFeed() {
  const [comments, setComments] = useState<Comment[]>(initialComments);
  const [loadedExtra, setLoadedExtra] = useState(0);
  const [newComment, setNewComment] = useState('');
  const [rating, setRating] = useState(0);
  const [hoverRating, setHoverRating] = useState(0);
  const [showThankYou, setShowThankYou] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!newComment.trim()) return;
    setShowThankYou(true);
    setNewComment('');
    setRating(0);
    setTimeout(() => setShowThankYou(false), 4500);
  };
  const toggleLike = (id: number) => {
    setComments(prev => prev.map(c => c.id === id ? {
      ...c,
      liked: !c.liked,
      likes: c.liked ? c.likes - 1 : c.likes + 1
    } : c));
  };
  const loadMore = () => {
    const next = moreCommentsPool.slice(loadedExtra, loadedExtra + 5);
    setComments(prev => [...prev, ...next]);
    setLoadedExtra(prev => prev + 5);
  };
  const hasMore = loadedExtra < moreCommentsPool.length;
  return <section className="w-full bg-cream-alt py-12 md:py-20 px-4 md:px-6" data-id="element-250">
      <div className="max-w-3xl mx-auto" data-id="element-251">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-8 md:mb-12" data-id="element-252">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-display font-bold text-navy-primary mb-2 md:mb-3" data-id="element-253">
            Opinie trenerów którzy już używają systemu
          </h2>
          <p className="text-sm md:text-base text-gray-600" data-id="element-254">
            Ponad 1 200 trenerów zmieniło już swój sposób trenowania
          </p>
        </motion.div>

        {/* Comment Form */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-white rounded-2xl shadow-lg p-5 md:p-8 mb-6 md:mb-8 border border-gold-accent/20" data-id="element-255">
          <h3 className="text-lg md:text-xl font-bold text-navy-primary mb-3 md:mb-4" data-id="element-256">
            Zostaw swoją opinię:
          </h3>

          <AnimatePresence mode="wait" data-id="element-257">
            {showThankYou ? <motion.div key="thanks" initial={{
            opacity: 0,
            scale: 0.95
          }} animate={{
            opacity: 1,
            scale: 1
          }} exit={{
            opacity: 0,
            scale: 0.95
          }} className="bg-green-50 border border-green-200 rounded-xl p-4 md:p-6 flex items-start gap-3 md:gap-4" data-id="element-258">
                <CheckCircle2 className="w-6 h-6 md:w-8 md:h-8 text-green-600 flex-shrink-0" data-id="element-259" />
                <div data-id="element-260">
                  <p className="font-bold text-green-800 text-base md:text-lg mb-1" data-id="element-261">
                    Dziękujemy za Twoją opinię!
                  </p>
                  <p className="text-sm md:text-base text-green-700" data-id="element-262">
                    Twoja opinia zostanie opublikowana wkrótce po weryfikacji.
                  </p>
                </div>
              </motion.div> : <motion.form key="form" initial={{
            opacity: 0
          }} animate={{
            opacity: 1
          }} onSubmit={handleSubmit} data-id="element-263">
                <textarea value={newComment} onChange={e => setNewComment(e.target.value)} placeholder="Napisz o swoich doświadczeniach z systemem FUTBOL GOTOWY..." rows={3} className="w-full p-3 md:p-4 rounded-xl border border-gray-200 focus:border-gold-accent focus:outline-none transition-colors resize-none text-sm md:text-base text-gray-700 placeholder-gray-400" data-id="element-264" />

                <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 mt-4" data-id="element-265">
                  <div className="flex items-center gap-2 md:gap-3" data-id="element-266">
                    <span className="text-sm md:text-base text-gray-600 font-medium" data-id="element-267">
                      Oceń:
                    </span>
                    <div className="flex gap-1" data-id="element-268">
                      {[1, 2, 3, 4, 5].map(star => <button key={star} type="button" onMouseEnter={() => setHoverRating(star)} onMouseLeave={() => setHoverRating(0)} onClick={() => setRating(star)} className="transition-transform hover:scale-110" aria-label={`Oceń na ${star} gwiazdek`} data-id="element-269">
                          <Star className={`w-6 h-6 md:w-7 md:h-7 transition-colors ${(hoverRating || rating) >= star ? 'fill-gold-accent text-gold-accent' : 'text-gray-300'}`} data-id="element-270" />
                        </button>)}
                    </div>
                  </div>

                  <motion.button type="submit" whileHover={{
                scale: 1.03
              }} whileTap={{
                scale: 0.97
              }} disabled={!newComment.trim()} className="bg-navy-primary hover:bg-navy-dark text-white font-bold px-6 py-2.5 md:px-8 md:py-3 rounded-full shadow-md disabled:opacity-50 disabled:cursor-not-allowed transition-colors text-sm md:text-base w-full sm:w-auto" data-id="element-271">
                    Wyślij opinię
                  </motion.button>
                </div>
              </motion.form>}
          </AnimatePresence>
        </motion.div>

        {/* Comments List */}
        <div className="space-y-4" data-id="element-272">
          <AnimatePresence data-id="element-273">
            {comments.map((comment, index) => <motion.div key={comment.id} initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} exit={{
            opacity: 0
          }} transition={{
            duration: 0.4,
            delay: index < 5 ? index * 0.05 : 0
          }} className="bg-white rounded-2xl p-4 md:p-6 shadow-sm border border-gray-100" data-id="element-274">
                <div className="flex items-start justify-between gap-3 mb-2" data-id="element-275">
                  <div className="flex items-center gap-2 md:gap-3 min-w-0" data-id="element-276">
                    <div className="w-8 h-8 md:w-10 md:h-10 rounded-full bg-navy-primary flex items-center justify-center flex-shrink-0" data-id="element-277">
                      <User className="w-4 h-4 md:w-5 md:h-5 text-gold-accent" data-id="element-278" />
                    </div>
                    <span className="font-bold text-navy-primary text-sm md:text-base truncate" data-id="element-279">
                      {comment.handle}
                    </span>
                  </div>
                  <div className="flex gap-0.5 flex-shrink-0" data-id="element-280">
                    {[...Array(comment.rating)].map((_, i) => <Star key={i} className="w-3 h-3 md:w-4 md:h-4 fill-gold-accent text-gold-accent" data-id="element-281" />)}
                  </div>
                </div>

                <p className="text-sm md:text-base text-gray-700 leading-relaxed mb-3" data-id="element-282">
                  {comment.comment}
                </p>

                <div className="flex items-center gap-3 md:gap-4 text-xs md:text-sm" data-id="element-283">
                  <button onClick={() => toggleLike(comment.id)} className="flex items-center gap-1.5 group" aria-label="Lubię to" data-id="element-284">
                    <Heart className={`w-4 h-4 md:w-5 md:h-5 transition-all group-hover:scale-110 ${comment.liked ? 'fill-red-500 text-red-500' : 'text-gray-400 group-hover:text-red-400'}`} data-id="element-285" />
                    <span className={comment.liked ? 'text-red-500 font-medium' : 'text-gray-500'} data-id="element-286">
                      {comment.likes}
                    </span>
                  </button>
                  <span className="text-gray-400" data-id="element-287">•</span>
                  <span className="text-gray-500" data-id="element-288">{comment.time}</span>
                </div>
              </motion.div>)}
          </AnimatePresence>
        </div>

        {/* Load More Button */}
        {hasMore && <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="flex justify-center mt-6 md:mt-8" data-id="element-289">
            <motion.button whileHover={{
          scale: 1.03
        }} whileTap={{
          scale: 0.97
        }} onClick={loadMore} className="bg-white hover:bg-cream-bg text-navy-primary font-bold px-6 py-2.5 md:px-8 md:py-3 rounded-full shadow-sm border border-navy-primary/10 hover:border-gold-accent transition-all text-sm md:text-base" data-id="element-290">
              Załaduj 5 kolejnych opinii
            </motion.button>
          </motion.div>}

        {!hasMore && comments.length > 5 && <p className="text-center text-gray-500 mt-6 md:mt-8 text-xs md:text-sm" data-id="element-291">
            Widzisz wszystkie opinie
          </p>}
      </div>
    </section>;
}